/** Opt in to owned saved creatives only; competitor and unspecified creation stay separate. */
export function storedBrandAdRemakeRequest(message:string):boolean {
  const text=message.trim();
  if(/\b(?:competitors?|rivals?)\b/i.test(text))return false;
  if(/\b(?:don['’]?t|do\s+not|never|hypothetically|what\s+if|hold\s+off)\b/i.test(text))return false;
  const action=text.replace(/^(?:please\s+)?(?:can|could|would|will)\s+you\s+(?:please\s+)?/i,'').replace(/^please\s+/i,'');
  if(!/^(?:make|create|generate|build|produce|remake|clone|copy|adapt|use)\b/i.test(action))return false;
  const ownCollection=/\b(?:brand\s+analysis|ad\s+intelligence|adna)\b/i.test(text)
    || /\b(?:my|our|the\s+selected|the\s+current)\s+brand(?:['’]s)?\s+(?:(?:own|stored|saved|existing)\s+)*ads?\b/i.test(text);
  if(!ownCollection||! /\bads?\b/i.test(text))return false;
  if(/^(?:use)\b/i.test(action))return /\b(?:remake|clone|copy|adapt|generate|make|create|build|produce)\b|\bas\s+(?:inspiration|references?|templates?)\b/i.test(action.slice(3));
  return !/\b(?:ideas?|advice|examples?|feedback|copy\s+ideas|headlines?)\b/i.test(action);
}
